module.exports = __webpack_public_path__ + "static/media/china_paper_cups_getty_mobile.d01922d4.jpg";